import { LenderUser } from 'app/models/dto/lender-user.model';

export class GetClaimRestrictions {
  static readonly type = '[ClaimLead] GetClaimRestrictions';
  constructor() { }
}

export class SubscribeToUnattemptedLeads {
	static readonly type = '[ClaimLead] SubscribeToUnattemptedLeads';
	constructor(public lenderUser: LenderUser) {}
}

export class UnsubscribeFromUnattemptedLeads {
	static readonly type = '[ClaimLead] UnsubscribeFromUnattemptedLeads';
	constructor(public userId: number) {}
}

export class SubscribeToJumpballNotify {
  static readonly type = '[ClaimLead] SubscribeToJumpballNotify';
  constructor(public lenderUser: LenderUser) { }
}

export class UnsubscribeFromJumpballNotify {
	static readonly type = '[ClaimLead] UnsubscribeFromUJumpballNotify';
	constructor(public lenderUser: LenderUser) { }
}

export class SetNextAssignment {
	static readonly type = '[ClaimLead] SetNextAssignment';
	constructor(public val: boolean) {}
}

export class SetFlagHighPriority {
	static readonly type = '[ClaimLead] SetFlagHighPriority';
	constructor(public val: boolean) {}
}

export class ClaimAssignment {
  static readonly type = '[ClaimLead] ClaimAssignment';
  constructor() {}
}

export class ResetConflict {
	static readonly type = '[ClaimLead] ResetConflict';
	constructor() {}
}
